module.exports = __webpack_public_path__ + "img/user.dd2fe133.png";